// extracted by mini-css-extract-plugin
export default {"select":"ItemDropdown_select__X4yDo","buffer":"ItemDropdown_buffer__+Wi64"};